// Tvar slova podle počtu (S3 #399). Čeština a slovenština mají stejná pravidla:
// 1 → forms[0], 2–4 → forms[1], jinak (0, 5 a víc, desetinné) forms[2].
// Tvary samy žijí v textech jazyka (`locale/<jazyk>/<modul>.js`), sem patří jen
// pravidlo. Jazyk s jinými pravidly by dostal vlastní funkci vedle svých textů.
//
//   plural(3, ['položka', 'položky', 'položek'])  → 'položky'
export function plural(count, forms) {
  const n = Number(count);
  if (n === 1) return forms[0];
  if (n >= 2 && n <= 4) return forms[1];
  return forms[2];
}
